
import { ref, useContext, watch, computed } from '@nuxtjs/composition-api'
import usePlaymix from '@/composable/usePlaymix'
import { SELECTION_TEXT_MIX_4, SELECTION_TEXT_MIX_3 } from '@/constants/PlayMix'

export default {
  props: {
    identifier: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    bundleId: {
      type: String,
      default: null
    },
    invertedVersion: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const { app } = useContext()
    const { getPlayMixServices, selected, selection, data, selectedPlayServices } = usePlaymix(props.identifier, app.$hubble)

    getPlayMixServices(props.bundleId)

    const showServicePicker = ref(props.active)

    const toggle = (bool) => {
      showServicePicker.value = bool
    }

    watch(selected, () => {
      // emit event when all has been choosen
      if (data.value && selected.value.length === data.value.mixVasLimit) {
        setTimeout(() => { // wait for animation to finish
          const selectedServices = data.value.productOfferingDTOWithContent.filter((_item, i) => selection.value.includes(i))
          selectedPlayServices.value = selectedServices.map(val => val.productOfferingDTO.id)
          emit('success', {
            selectedServices: data.value.productOfferings.filter((_item, i) => selection.value.includes(i))
          })
        }, 400)
      } else {
        emit('deselected', {
          selectedServices: data.value.productOfferings.filter((_item, i) => selection.value.includes(i))
        })
      }
    })
    const selectionText = computed(() => {
      if (data.value.mixVasLimit === 3) {
        return SELECTION_TEXT_MIX_3
      } else {
        return SELECTION_TEXT_MIX_4
      }
    })
    return {
      selectionText,
      selection,
      data,
      selected,
      showServicePicker,
      toggle
    }
  },
  watch: {
    active: function (newVal) {
      this.showServicePicker = newVal
    }
  }
}
